import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import SearchView from "../../../widgets/SearchView";
import ModuleSetupSearchForm from './../Module/ModuleSetupSearchForm';
import { ViewContainer } from "./../../../View.jsx";
import ViewUtils from "./../../../ViewUtils";
import withMenuPermission from "../../../widgets/withMenuPermission";


const headCells = [
    { id: 'ModuleCode', numeric: false, disablePadding: true, label: 'Module Code' },
    { id: 'ModuleTitle', numeric: false, disablePadding: true, label: 'Module Title' }
];

const utils = new ViewUtils();

class ModuleSetupSearch extends Component {
    constructor(props) {
        super(props)

        this.searchParameters = !utils.isNull(this.props.TradeQualificationID) ? [
            { Name: "ModuleCode", Value: "" },
            { Name: "ModuleTitle", Value: "" },
            { Name: "TradeQualificationID", Value: this.props.TradeQualificationID }
        ]
            :
            [
                { Name: "ModuleCode", Value: "" },
                { Name: "ModuleTitle", Value: "" }
            ];

        this.state = {
            model: {
                ModuleCode: "",
                ModuleTitle: ""
            },
            selectedModuleProgramme: null,
            keyUpSwitch: false
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: '', tooltip: 'Remove Module', icon: 'DeleteIcon', disabled: true, visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        }
    }

    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer title="">
                <SearchView headCells={headCells} dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/Modulesetup/getsearch"}
                    entityViewPath='/moduleSetup'
                    title='Module'
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="ModuleTitle" mode={this.props.mode}
                    keyUpSwitch={this.state.keyUpSwitch}
                    history={this.props.history}
                    multiSelect={this.props.multiSelect}
                    deleteUrl={"api/sims/ModuleSetup/RemoveModule"} useDeletePost={true}
                    promptTitle={"Remove Module Programme"} selectionCallbackMode={this.props.selectionCallbackMode}
                    promptContent={"Removing the Module programme is a permanent action and the Module programme will not be available going forward. Are you sure you want to remove this Module programme?"}
                >
                    <ModuleSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>

        );
    }
}

export default withRouter(withMenuPermission(ModuleSetupSearch));

